import { context } from '@wikia/ad-engine';

export function getPubmaticContext(): object {
	const floorAdhesionConfig = context.get('experiments.persistentAdhesionExperiment')
		? {
				adhesion_limited: {
					sizes: context.get('experiments.oversizedAds')?.mobile?.adhesion_limited ?? [
						[300, 50],
						[320, 50],
					],
					/* Changing this to adSlot for adhesion_limited as per:
					 * https://fandom.atlassian.net/browse/ADEN-14222?focusedCommentId=787612
					 */
					adSlot: ['6068053'],
				},
			}
		: {};

	return {
		enabled: false,
		publisherId: '156260',
		slots: {
			featured: {
				sizes: [[0, 0]],
				ids: ['1636187@0x0'],
			},
			incontent_player: {
				sizes: [[0, 0]],
				ids: ['1636188@0x0'],
			},
			interstitial: {
				sizes: [[320, 480]],
				ids: ['Fandom_Mobile_Interstitial'],
			},
			gallery_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.gallery_leaderboard ?? [
					[320, 100],
					[320, 50],
				],
				ids: ['5315749'],
			},
			mobile_top_leaderboard: {
				sizes: [[320, 50]],
				ids: ['/5441/MOBILE_TOP_LEADERBOARD_320x50@320x50'],
			},
			mobile_in_content: {
				sizes: [[300, 250]],
				ids: ['/5441/MOBILE_IN_CONTENT_300x250@300x250'],
			},
			bottom_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.bottom_leaderboard ?? [
					[300, 250],
					[320, 50],
				],
				ids: ['/5441/MOBILE_PREFOOTER_300x250@300x250', '/5441/MOBILE_PREFOOTER_320x50@320x50'],
			},
			...floorAdhesionConfig,
		},
	};
}
